import { BaseDocument } from '../../../base/BaseDocument';
import { IBaseEntry } from '../../../base/interfaces/IBaseEntry';
export class MeasurementStandard extends BaseDocument implements IBaseEntry {
    requestId:string;
    requestCode:string;
    customerName:string;
    layoutId:string;
    layout2Id:string;
    intrixId:string;
    floorId:string;
    wallFloorLiningId:string;
    wallFloorLiningHeight:number;
    wallFloorLiningThickness:number;
    onsitePicture1:string;
    onsitePicture2:string;
    onsitePicture3:string;
    layout1:number;
    layout2:number;
    wallFloorLeft:boolean;
    wallFloorRight:boolean;
    wallFloorBack:boolean;
    electric:boolean;
    electricPrepareMoveId:string;
    electricPrepareCutsId:string;
    electricPreparAassemblyId:string;
    additionalCuts:boolean;
    additionalCutsLocationId:string;
    signatureId:string;
    intrixDocumentId:string;
}
